<template>
  <div>
    <iframe
      width="100%"
      :height="height+'px'"
      @click="changeUrl"
      :src="iframeUrl"
      id="reportFrame"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
import urlSettings from '@/config/url-settings.js';
export default {
  props: {
    height:{
      type: Number,
      default:0,
    },
    params: { type: Object },
    roomName: { type: String },
    areaName: { type: Number },
    name: { type: String },
    url: { type: String },
    // src: { type: String },
  },
  data() {
    return {
      iframeUrl: '',
    };
  },

  mounted() {
    if(!this.height){
      this.height = this.bodyHeight - 226
    }
    this.iframeUrl = this.addUrlParams(this.url, this.params);
  },

  methods: {
    changeUrl() {
      this.iframeUrl = this.addUrlParams(this.url, this.params);
    },
    regroupUrl() {
      this.iframeUrl = this.addUrlParams(this.url, this.params);
      console.log(this.params);
      console.log("报表请求路径："+this.iframeUrl);
    },
    addUrlParams(url, obj) {
      Object.keys(obj).forEach((item) => {
        if (item == 'reportlet') {
          url += '?' + item + '=';
          url += obj[item];
        } else {
          url += '&' + item + '=';
          url += obj[item];
        }
      });
      url +=  '&tenantId=' +  urlSettings.TENANTID;
      return url;
    },
  },
};
</script>

<style></style>
